import { IconName } from "@blueprintjs/core";
import React, { ReactNode } from "react";

import { IViewProps, View } from "core/decorators/View";
import Icon from "./Icon";
import IconViewConfig from "./IconConfig";


interface IIconViewProps<T extends ("bp" | "external") = "bp"> extends IViewProps<IconViewConfig> {
	icon: (T extends "bp" ? IconName : string) | ReactNode;
	type?: T;
}

@View({id: "icon", configClass: IconViewConfig})
export default class IconView<T extends ("bp" | "external") = "bp"> extends React.PureComponent<IIconViewProps<T>> {

	public render() {
		const { children, config, icon, type } = this.props;

		if(React.isValidElement(icon)) {
			return (
				<React.Fragment>
					{icon}
					{children}
				</React.Fragment>
			);
		}

		return (
			<Icon config={config} icon={icon as any} children={children} type={type} />
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/icon/Icon.view.tsx